import React from "react";
import cls from "clsx";
import LoadingIndicator from "./LoadingIndicator";

const SmallerLoadingIndicator = ({ className, style }) => {
  return (
    <div className={cls("smaller-loading-indicator", className)} style={style}>
      <LoadingIndicator />
    </div>
  );
};

export default SmallerLoadingIndicator;
